export default __webpack_public_path__ + "static/0-afbf782bd7762f6760d5d776c5fbbc30.png";